import { storage } from 'BASE/common/util/util.storage';
import { issueHandleInfo } from 'BASE/common/bet/bet.issueHandler';

export function getlottoID(code) {
    let data = storage.temp.get(storage.keys.LOTTERY_GAME_DATA);
    if(!data) {
        return undefined;
    }
    
    let lottogameID = Object.keys(data).find(key => data[key].Code == code);
    return lottogameID ? parseInt(lottogameID) : undefined;
}

export async function getInfo(updateFunc, input) {
    let infos;
    let infoKeys;
    let gameIdList = input.gameIds.slice();
    do {
        infos = {};
        infoKeys = [];
        let data = await $.postJSON('/api/LotteryGame/Info', {
            GameIdList: gameIdList,
            State: input.state,
            LastIssue: input.lastIssue,
            LastDrawIssue: input.lastDrawIssue,
            Countdown: input.countdown,
            SelectCount: input.selectCount,
            OldIssues: input.oldIssues
        });

        for (let key in data) {
            let i = new issueHandleInfo(data[key]);
            if (input.countdown) {
                i.handleIssueChange();
            }
            infos[key] = i;
        }

        updateFunc(infos);
        infoKeys = Object.keys(infos).map(Number);
        gameIdList = gameIdList.filter(id => infoKeys.indexOf(id) < 0);
       
    } while(gameIdList.length > 0 && infoKeys.length > 0)
}

export function updateIssue(gameInfos, gameId, closeIssue) {
    let gameInfo = (gameInfos || {})[gameId];
    if (!gameInfo) {
        return null;
    }

    gameInfo.handleIssueChange({ closeIssue });
    return gameInfo;
}

export function updateLastWinNum(gameInfos, gameId, serialNumber, winningNumber, drawTimeStamp) {
    let gameInfo = (gameInfos || {})[gameId];
    if (!gameInfo) {
        return null;
    }
    // update if newer
    if (Array.isArray(gameInfo.LastIssue)) {
        if (gameInfo.lastIssue[0] && parseInt(serialNumber, 10) >= parseInt(gameInfo.lastIssue[0].serialNumber, 10)) {
            gameInfo.lastIssue.unshift({ serialNumber, winningNumber, drawTimeStamp });
            gameInfo.lastIssue.pop()
        }
    } else {
        if (gameInfo.lastIssue && parseInt(serialNumber, 10) >= parseInt(gameInfo.lastIssue.serialNumber, 10)) {
            gameInfo.lastIssue.serialNumber = serialNumber;
            gameInfo.lastIssue.winningNumber = winningNumber;
            gameInfo.lastIssue.drawTimeStamp = drawTimeStamp;
        }
    }
    return gameInfo;
}

export function updateOldIssueWinNum(gameInfos, gameId, serialNumber, winningNumber) {
    let gameInfo = (gameInfos || {})[gameId];
    if (!gameInfo) {
        return null;
    }

    let issues = [...gameInfo.oldIssues, gameInfo.currentIssue, ...gameInfo.recentIssues].filter(i => i != null);
    let issue = issues.find(i => i.serialNumber == serialNumber);
    if (issue) {
        issue.winningNumber = winningNumber;
    }
    return gameInfo;
}

var _promise = null;
export async function getLottoGameData() {
    let data = storage.temp.get(storage.keys.LOTTERY_GAME_DATA);
    if (data)
        return data;
    
    if (!_promise) {
        _promise = new Promise(async resolve => {
            let data = await $.postJSON('/api/LotteryGame/Data');
            storage.temp.set(storage.keys.LOTTERY_GAME_DATA, data);
            resolve(data);
        });
    }
    return _promise;
}